import { DEFAULT_LOCALE } from './constants';
import { initLocaleStore } from './localeStore';

initLocaleStore(DEFAULT_LOCALE);
